<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Acknowledgments">
<p class="h2" id="ack"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii"><a href="#/text/Contents#rack">Acknowledgments</a></span></p>
<p class="noindent"><span class="dropcap">F</span><span class="small">IRST AND FOREMOST,</span> I would like to thank Ray Cashman for his tireless efforts, patience, and insightful feedback throughout the process of seeing this edited volume to fruition. I am also grateful to Janice E. Frisch, Gary Dunham, Rachel Rosolina, and David Miller at Indiana University Press and Pete Feely at Amnet for seeing through the volume’s production. Thanks also to Eileen Allen for creating the index. This volume began as a panel that I chaired at the 2013 American Folklore Society Annual Meeting, for which Sue Tuohy generously served as discussant. Thanks to Emily Wilcox for securing permission from Siqintariha for the wonderful cover photo, and to Michael Dylan Foster for providing valuable support early on in the project. Thanks also to Hilary Warner-Evans, Kristina Downs, Marisa Wieneke, and Ray Cashman for their careful editing work and to the anonymous reviewers of the individual chapters for their valuable comments and suggestions. Lastly, I want to thank Helen Rees for patiently providing helpful feedback along the way.<span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?51120f52